var _g, _g2, _path, _path2, _path3, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3,3)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 100 C75 72 52 52 30 52 C8 52 10 148 30 148 C52 148 125 52 150 52 C172 52 192 72 192 100 C192 128 172 148 150 148 C125 148 75 52 50 52",
    fill: "none",
    stroke: "#00FFFF",
    strokeWidth: 18,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3,-3)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 100 C75 72 52 52 30 52 C8 52 10 148 30 148 C52 148 125 52 150 52 C172 52 192 72 192 100 C192 128 172 148 150 148 C125 148 75 52 50 52",
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 18,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 100 C75 72 52 52 30 52 C8 52 10 148 30 148 C52 148 125 52 150 52 C172 52 192 72 192 100 C192 128 172 148 150 148 C125 148 75 52 50 52",
    fill: "none",
    stroke: "white",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100 C75 72 52 52 30 52 C8 52 10 148 30 148 C52 148 125 52 150 52 C172 52 192 72 192 100 C192 128 172 148 150 148 C125 148 75 52 50 52",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100 C75 72 52 52 30 52 C8 52 10 148 30 148 C52 148 125 52 150 52 C172 52 192 72 192 100 C192 128 172 148 150 148 C125 148 75 52 50 52",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    transform: "translate(3,3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 100,
    r: 10,
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 103,
    r: 10,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.3822d2b37adeedf6a7b7b450b5fb5dd9.svg";
export { ForwardRef as ReactComponent };